import color from "../../../../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: '0px 20px 0px 10px'
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "22px",
  },
  noDataText: {
    fontSize: "14px",

  },
  crossIcon: {
    mx: 1.5,
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400"
  },
  gridContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputSectionField: {
    width: "40%"
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mb: 1
  },
  labelType: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1
  },
  dropdown: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },

  table: {
    border: "1px solid rgba(224, 224, 224, 1)",
    mt: 2,
    borderRadius: "10px"

  },
  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",
    },
  },
  tabledata: {
    border: 0
  },
  btnGridAction: {
    width: "100%",
    ml: { xs: 1, md: 0 }
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  deleteIcon: {
    p: 1,
    // pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"

  },

  dropdowns: {
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    // mt: 1,
    borderRadius: "10px"
  },
  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },

  gridbioBox: {
    backgroundColor: "#ffff",
    m: 3,
    p: 3,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  inputSection: {
    // display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },
  inputSection1: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2,
    paddingBottom: "10px"
  },
  inputSections: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",

    px: 2
  },

  inputSectionFull: {
    px: 2
  },
  permissionLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    mx: 1,
  },

  greyLine: {
    border: "1.5px solid #D9D9D9",
    width: "100%",
    my: 2
  },

  lineTextGrid: {
    display: "flex",
    alignItems: "center",
    mx: 1,
    my: 2

  },


  leaveSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },
  mainContainer: {
    px: "15px",
    pt: "20px",
    mt: 2,
    width: "100%",
  },
  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-13ghu1p": {
      py: "5px"

    }
  },
  printbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.lightText,
    mr: "10px",
    // my: 4,
    fontSize: "12px",
    px: 3,
    ml: 2

  },
  formControlLabel: {
    m: 0,
    " & .css-1ismtrt-MuiTypography-root": {
      fontSize: "14px",
      width: "100%",
    }
  },


  inputBox: {
    // width: { xs: "100%", md: "49%", lg: "49%" },
    display: { xs: "block", md: "flex" },
    justifyContent: "space-between",
    alignItems: "center"

  },
  inputBoxes: {
    width: { xs: "100%", md: "33%", lg: "32%" },
  },
  dateInput: {
    width: "33%",
    mt: 1,

    // padding:2,
    "& .css-6193sp-MuiInputBase-root-MuiOutlinedInput-root ": {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  input: {
    width: { xs: "100%", md: "33%", lg: "32.5%" }
  },
  downloadIcon: {
    mr: 1,
    fontSize: "4px",
  },

  inputBoxfullWidth: {
    width: "100%"
  },
  additionalBox: {
    width: { xs: "100%", md: "49%", lg: "32%" }
  },

  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 2,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  gridText: {
    // mx:2,
    fontSize: "14px",
    fontWeight: "500"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    m: "10px",
    px: "10px",
    display: "flex",
    mb: 3,
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },
  },
  addButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    mt: 2

  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,

  },


  switchKeyText: {
    width: { xs: "60%", md: "32%" }
  },
  switchContent: {
    fontSize: "12px",
    fontWeight: "500",
  },
  descText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.text,
  },
  descValueText: {
    fontSize: "14px",
    fontWeight: "500",
    color: color?.text,
  },
  infoSection: {
    px: 3,
  },
  bioIconText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  textPrimary: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
  },
  line: {
    border: "1px solid #D9D9D9",
    my: 2,
    mx: 3
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: "600"
  },
  contactSection: {
    mt: 4,
  },

  contenttSection: {
    mt: 2.5,
  },
  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    },
  },
  dropdownLeave: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    height: "2.5em",

    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    }
  },

  durationText: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",

  },
  contactSubheading: {
    fontSize: "18px",
    fontWeight: "600",

  },
  infoBox: {
    display: "flex",
    mb: 1.5,
  },
  bioText: {
    fontSize: "14px",
    fontWeight: "600",
  },
  bioTextValue: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,

  },
  productSection: {
    px: 2,

    "& .css-2y07vr": {
      py: "7px"

    }

  },
  bioTextValueSuccess: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,
    color: color.primary,

  },
  detailText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text
  },
  productText: {
    fontSize: "14px",
    fontWeight: "400",
    mb: 1
  },

  closeJob: {
    color: "#FF0000",
    fontSize: "14px",
  },
  removeSection: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    mt: 2,

  },
  liText: {
    fontSize: "14px",
    listStyle: "disc !important",
    display: "list-item",
  },
  createJob: {
    textAlign: "center",
  },
  exportBtn: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "& svg": {
      mr: 1
    }
  }
};

export default style;